import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { PropTableValues } from "../../../../src/components";
import { Label } from '@primer/react';
import { Button, Heading, Text } from '@primer/react-brand';
import { SearchIcon } from '@primer/octicons-react';
import { Link } from 'gatsby';
import * as React from 'react';
export default {
  InlineCode,
  PropTableValues,
  Label,
  Button,
  Heading,
  Text,
  SearchIcon,
  Link,
  React
};